module.exports = __webpack_public_path__ + "static/media/user.2d9d5766.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user.png
// module id = 314
// module chunks = 0